'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditIcon = function EditIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M4.01340722,27.038 C3.97340722,27.206 4.02440722,27.383 4.14640722,27.506 C4.26440722,27.625 4.43840722,27.68 4.61440722,27.639 L11.0804072,26.123 C11.1234072,26.113 11.1634072,26.096 11.2024072,26.076 L5.57740722,20.451 C5.55640722,20.489 5.54040722,20.53 5.53040722,20.573 L4.01340722,27.038 Z M25.8585749,11.451131 L25.1511749,12.158031 L19.4959749,6.498831 L20.2033749,5.791931 L25.8585749,11.451131 Z M24.4459369,12.8634719 L11.9253172,25.3840916 L6.26851722,19.7272916 L18.7891369,7.2066719 L24.4459369,12.8634719 Z M26.5674072,10.742 L26.9214072,10.388 C27.8964072,9.414 27.8964072,7.828 26.9214072,6.853 L24.8004072,4.733 C24.3284072,4.259 23.7004072,4 23.0324072,4 C22.3644072,4 21.7364072,4.26 21.2644072,4.733 L20.9104072,5.086 L26.5674072,10.742 Z' })
  );
};

EditIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = EditIcon;